export default __webpack_public_path__ + "static/healthCareBg-84abffaace75591385afc94b1de08594.png";